import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import BankScopeField from '../../components/BankScopeField';
import LotteryCodeField from '../../components/LotteryCodeField';
import PayTicketDetailModal from '../../components/PayTicketDetailModal';
import DateField from '../../components/DateField';
import { payTicket, searchPayTickets } from '../../api/payTicket';
import { todayISO } from '../../utils/date';
import { bankLabel } from '../../utils/bank';
import './PayTicketPage.css';

// Portail (2026-09-26) : la MEME page sert la company (configuration par defaut
// ci-dessous) et le superviseur (pages/supervisor/supervisorCentralPortal.jsx :
// SupervisorLayout, API limitee a SES banks, champ Banque superviseur).
const COMPANY_PORTAL = {
  Layout,
  homePath: '/dashboard',
  centralPath: '/central',
  BankField: BankScopeField,
  search: searchPayTickets,
  action: payTicket,
};

const PayTicketPage = ({ portal = COMPANY_PORTAL }) => {
  const [bank, setBank] = useState('');
  const [bankName, setBankName] = useState('');
  const [lottery, setLottery] = useState('');
  const [lotteryName, setLotteryName] = useState('');
  const [numero, setNumero] = useState('');
  const [date, setDate] = useState(todayISO());

  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedTicket, setSelectedTicket] = useState(null);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!bank || !numero) {
      setError('Renseigne la banque et le N° de fiche.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const data = await portal.search({ bank, no: numero, tirage: lottery, date });
      setResults(data.rows);
      setSearched(true);
    } catch (err) {
      setError('Recherche impossible.');
    } finally {
      setLoading(false);
    }
  };

  const handlePay = async (ticketId) => {
    const updated = await portal.action(ticketId);
    setResults((prev) => prev.map((t) => (t.id === ticketId ? updated : t)));
    setSelectedTicket(updated);
  };

  return (
    <portal.Layout>
      <p className="pt-breadcrumb">
        Ruta : <Link to={portal.homePath} className="bc-link">Menu</Link>
        {' >> '}
        <Link to={portal.centralPath} className="bc-link">Central</Link>
        {' >> '}
        <span className="bc-current">Pay Ticket</span>
      </p>

      <div className="pt-card">
        <div className="pt-card-header">
          <span className="pt-card-title">Pay Ticket</span>
        </div>
        <div className="pt-card-body">
          <form onSubmit={handleSearch} className="pt-form">
            <div className="pt-fields">
              <div className="pt-col">
                <div className="pt-row">
                  <label className="pt-label">Banque</label>
                  <portal.BankField
                    id={bank}
                    name={bankName}
                    onResolve={(id, nm) => { setBank(id); setBankName(nm); }}
                    inputClass="pt-input pt-input-sm"
                    iconClass="pt-icon-btn"
                    nameClass="pt-bank-name"
                    errClass="pt-lookup-err"
                  />
                </div>

                <div className="pt-row">
                  <label className="pt-label">Loterie</label>
                  <LotteryCodeField
                    value={lottery}
                    name={lotteryName}
                    onChange={(code) => { setLottery(code); setLotteryName(''); }}
                    onResolve={(code, nm) => { setLottery(code); setLotteryName(nm); }}
                    inputClass="pt-input pt-input-sm"
                    iconClass="pt-icon-btn"
                    nameClass="pt-bank-name"
                  />
                </div>
              </div>

              <div className="pt-col">
                <div className="pt-row">
                  <label className="pt-label">Date</label>
                  <DateField className="pt-input pt-input-date" value={date} onChange={setDate} />
                </div>

                <div className="pt-row">
                  <label className="pt-label">Ticket</label>
                  <input
                    className="pt-input pt-input-sm"
                    type="text"
                    inputMode="numeric"
                    value={numero}
                    onChange={e => setNumero(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <button type="submit" className="pt-search-btn" disabled={loading}>
              {loading ? 'Recherche...' : 'Chercher'}
            </button>

            {error && <p className="pt-error">{error}</p>}
          </form>

          {searched && (
            <table className="pt-table">
              <thead>
                <tr>
                  <th>SQ</th>
                  <th>No</th>
                  <th>Banque</th>
                  <th>Loterie</th>
                  <th>Total</th>
                  <th>Gagne</th>
                  <th>Paye?</th>
                  <th>Date</th>
                  <th>Heure</th>
                </tr>
              </thead>
              <tbody>
                {results.map((ticket) => (
                  <tr key={ticket.id} className="pt-row-hover" onClick={() => setSelectedTicket(ticket)}>
                    <td>{ticket.sq}</td>
                    <td>{ticket.no}</td>
                    <td>{bankLabel(ticket.bank_seq, ticket.bank_name)}</td>
                    <td>{ticket.tirage_name}</td>
                    <td>{ticket.total_amount}</td>
                    <td>{ticket.total_gain}</td>
                    <td>{ticket.is_paid ? 'Oui' : 'No'}</td>
                    <td>{ticket.date}</td>
                    <td>{ticket.time}</td>
                  </tr>
                ))}
                {results.length === 0 && (
                  <tr><td colSpan={9} className="pt-empty">Aucune fiche trouvée.</td></tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {selectedTicket && (
        <PayTicketDetailModal
          ticket={selectedTicket}
          onClose={() => setSelectedTicket(null)}
          onPay={handlePay}
        />
      )}
    </portal.Layout>
  );
};

export default PayTicketPage;
